<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="field mb-3">
        <label class="font-semibold">Nama Role</label>

        <InputText v-model="form.name" class="w-full" placeholder="Nama Role" />
      </div>

      <div class="field mb-4">
        <label class="font-semibold">Deskripsi</label>

        <InputText
          v-model="form.descriptions"
          class="w-full"
          placeholder="Deskripsi"
        />
      </div>
      <Accordion multiple>
        <AccordionTab
          v-for="(groups, appName) in groupedPermissions"
          :key="appName"
        >
          <template #header>
            <div class="flex align-items-center justify-content-between w-full">
              <span class="font-bold">
                {{ appName }}
              </span>

              <div class="flex align-items-center">
                <Checkbox
                  :binary="true"
                  :modelValue="isAppChecked(appName)"
                  :indeterminate="isAppIndeterminate(appName)"
                  @update:modelValue="toggleApp(appName, $event)"
                  @click.stop
                />

                <span class="ml-2 text-sm"> Select All </span>
              </div>
            </div>
          </template>

          <Accordion multiple>
            <AccordionTab
              v-for="(permissions, groupName) in groups"
              :key="groupName"
            >
              <template #header>
                <div
                  class="flex align-items-center justify-content-between w-full"
                >
                  <span>{{ groupName }}</span>

                  <div class="flex align-items-center">
                    <Checkbox
                      :binary="true"
                      :modelValue="isGroupChecked(appName, groupName)"
                      :indeterminate="isGroupIndeterminate(appName, groupName)"
                      @update:modelValue="
                        toggleGroup(appName, groupName, $event)
                      "
                      @click.stop
                    />
                    <span class="ml-2 text-sm"> Select All </span>
                  </div>
                </div>
              </template>

              <DataTable
                :value="permissions"
                stripedRows
                responsiveLayout="scroll"
              >
                <Column field="descriptions" header="Permission" />

                <Column header="Aktif" style="width: 120px">
                  <template #body="{ data }">
                    <Checkbox v-model="rights" :value="data.id" />
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </AccordionTab>
      </Accordion>

      <div class="flex justify-content-end">
        <Button
          label="Tutup"
          icon="pi pi-times"
          @click="$emit('close')"
          class="p-button-text mt-2 mr-2"
        />
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          class="mr-2 mt-2"
          type="submit"
        />
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
export default {
  setup: () => ({ v$: useVuelidate() }),

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {
          id: 0,
          name: '',
          permissions: [],
        }
      },
    },
    listPermission: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      submitted: false,
      rights: [],
      form: {
        id: null,
        name: '',
        descriptions: '',
      },
    }
  },
  computed: {
    groupedPermissions() {
      const grouped = {}

      this.listPermission.forEach((permission) => {
        const app = permission.app || 'OTHER'
        const group = permission.group || 'OTHER'

        if (!grouped[app]) {
          grouped[app] = {}
        }

        if (!grouped[app][group]) {
          grouped[app][group] = []
        }

        grouped[app][group].push(permission)
      })

      // urutan app yang diinginkan
      const appOrder = ['BIS', 'KONTRA', 'KP']

      const sorted = {}

      appOrder.forEach((app) => {
        if (grouped[app]) {
          sorted[app] = grouped[app]
        }
      })

      // app lain (kalau nanti ada tambahan)
      Object.keys(grouped)
        .filter((app) => !appOrder.includes(app))
        .sort()
        .forEach((app) => {
          sorted[app] = grouped[app]
        })

      return sorted
    },
  },
  mounted() {
    this.syncForm()
    this.updateRightsFromPermissions()
  },

  watch: {
    item: {
      handler() {
        this.syncForm()
        this.updateRightsFromPermissions()
      },
      deep: true,
    },
  },
  methods: {
    isGroupChecked(appName, groupName) {
      const ids = this.groupedPermissions[appName][groupName].map((p) => p.id)

      return ids.every((id) => this.rights.includes(id))
    },
    isGroupIndeterminate(appName, groupName) {
      const ids = this.groupedPermissions[appName][groupName].map((p) => p.id)

      const selected = ids.filter((id) => this.rights.includes(id))

      return selected.length > 0 && selected.length < ids.length
    },

    toggleGroup(appName, groupName, checked) {
      const ids = this.groupedPermissions[appName][groupName].map((p) => p.id)

      if (checked) {
        this.rights = [...new Set([...this.rights, ...ids])]
      } else {
        this.rights = this.rights.filter((id) => !ids.includes(id))
      }
    },
    getAppPermissionIds(appName) {
      return Object.values(this.groupedPermissions[appName])
        .flat()
        .map((p) => p.id)
    },
    isAppChecked(appName) {
      const ids = this.getAppPermissionIds(appName)

      return ids.every((id) => this.rights.includes(id))
    },
    isAppIndeterminate(app) {
      const ids = Object.values(this.groupedPermissions[app])
        .flat()
        .map((p) => p.id)

      const selected = ids.filter((id) => this.rights.includes(id))

      return selected.length > 0 && selected.length < ids.length
    },
    toggleApp(appName, checked) {
      const ids = this.getAppPermissionIds(appName)

      if (checked) {
        this.rights = [...new Set([...this.rights, ...ids])]
      } else {
        this.rights = this.rights.filter((id) => !ids.includes(id))
      }
    },
    groupSelectedCount(group) {
      const permissionIds = this.groupedPermissions[group].map(
        (permission) => permission.id
      )

      return permissionIds.filter((id) => this.rights.includes(id)).length
    },
    syncForm() {
      this.form = {
        id: this.item.id,
        name: this.item.name || '',
        descriptions: this.item.descriptions || '',
      }
    },
    handleSubmit(isFormValid) {
      this.submitted = true

      if (!isFormValid) {
        return
      }

      this.$emit('save', {
        id: this.form.id,
        name: this.form.name,
        descriptions: this.form.descriptions,
        permissions: this.rights,
      })
    },
    updateRightsFromPermissions() {
      this.rights = this.listPermission
        .filter((permission) =>
          this.item.permissions.some((p) => p.id === permission.id)
        )
        .map((permission) => permission.id)
    },
  },
}
</script>

<style scoped>
.group {
  margin-bottom: 20px;
}

.group-title {
  font-weight: bold;
  margin-bottom: 10px;
}

.permissions-row {
  display: flex;
  flex-wrap: wrap;
}

.card-column {
  flex: 0 0 calc(100% / 3); /* Three columns */
  padding: 0 10px; /* Adjust spacing between columns */
}

.align-items-start {
  align-items: flex-start; /* Align items to the start (left) */
}
</style>
